<template  >
  <div>

    <div class="mainBox">
      <h2>完善个人信息</h2>
      <Form
        ref="userInfoForm"
        :model="userInfoForm"
        :rules="userInfoRules"
        :label-width="130"
        class="form-container"
      >
        <FormItem label="工号：" prop="sid" class="mb30">
          <template v-if="sidDisabled">
            <!-- 如果 sidDisabled 为 true，则展示 Input 组件 -->
            <Input
              v-model="userInfoForm.sid"
              placeholder="请输入工号"
              :disabled="sidDisabled"
            ></Input>
          </template>
          <template v-else>
            <!-- 如果 sidDisabled 为 false，则展示特殊提示 -->
            <div>
              <span style="color: red"
                >如果您是同济大学的退休教职工，系统未读取到您的工号，请线下审核时与相关负责老师反馈</span
              >
            </div>
          </template>
        </FormItem>
        <FormItem label="姓名：" prop="name" class="mb30">
          <Input v-model="userInfoForm.name" placeholder="请输入姓名" :disabled="nameDisabled"></Input>
        </FormItem>
        <FormItem label="性别：" prop="sex" class="mb30">
          <Select v-model="userInfoForm.sex" placeholder="请选择性别" :disabled="sexDisabled">
            <Option value="1">男</Option>
            <Option value="2">女</Option>
          </Select>
        </FormItem>
        <FormItem
          label="证件类型："
          prop="idNumberType"
          style="margin-bottom: 40px"
        >
          <Select
            v-model="userInfoForm.idNumberType"
            placeholder="请选择证件类型"
            size="large"
            :disabled="true"
          >
            <Option value="idCard" key="idCard">身份证</Option>
            <Option value="passport" key="passport">护照</Option>
            <Option value="other" key="other">其他证件</Option>
          </Select>
        </FormItem>
        <FormItem
          :label="idNumberData.name + '号：'"
          class="mb30"
          prop="idCard"
        >
          <Input
            v-model="userInfoForm.idCard"
            :placeholder="'请输入' + idNumberData.name + '号'"
            :disabled="idCardDisabled"
            :maxlength="18"
          ></Input>
        </FormItem>
        <FormItem label="出生日期：" prop="birthDt" class="mb30">
          <DatePicker
            type="date"
            v-model="userInfoForm.birthDt"
            placeholder="请选择出生日期"
            @on-change="userInfoForm.birthDt = $event"
            format="yyyy-MM-dd"
            :disabled="userInfoForm.idNumberType === 'idCard'"
            :options="{
              disabledDate: (date) => {
                return date && date.valueOf() > Date.now();
              }
            }"
          ></DatePicker>
        </FormItem>
        <FormItem label="手机号码：" prop="phone" class="mb30">
          <Input
            v-model="userInfoForm.phone"
            placeholder="请输入手机号码"
            :disabled="telDisabled"
          ></Input>
        </FormItem>
        <FormItem label="电子邮箱：" prop="email" class="mb30">
          <Input v-model="userInfoForm.email" placeholder="请输入邮箱"></Input>
        </FormItem>
        <FormItem label="人员类型：" prop="studentType" class="mb30">
          <Select v-model="userInfoForm.studentType" placeholder="请选择类型">
            <Option value="1">离退休</Option>
            <Option value="2">在职</Option>
            <Option value="3">自由职业</Option>
          </Select>
        </FormItem>
        <FormItem label="工作单位：" prop="workUnit" class="mb30">
          <Input
            v-model="userInfoForm.workUnit"
            placeholder="请输入工作单位"
          ></Input>
        </FormItem>
        <FormItem label="家庭地址：" prop="address" class="mb30">
          <Input
            v-model="userInfoForm.address"
            placeholder="请输入家庭地址"
          ></Input>
        </FormItem>
        <FormItem
          label="紧急联系人姓名："
          prop="emergencyContactName"
          class="mb30"
        >
          <Input v-model="userInfoForm.emergencyContactName"></Input>
        </FormItem>
        <FormItem
          label="紧急联系人电话："
          prop="emergencyContactPhone"
          class="mb30"
        >
          <Input v-model="userInfoForm.emergencyContactPhone"></Input>
        </FormItem>
        <FormItem label="学历：" prop="education" class="mb30">
          <Select v-model="userInfoForm.education" placeholder="请选择类型">
            <Option value="大专及以上">大专及以上</Option>
            <Option value="初、高中（含中专）">初、高中（含中专）</Option>
            <Option value="初中以下">初中以下</Option>
          </Select>
        </FormItem>
        <FormItem label="" v-show="telDisabled">
          注意：<span style="color: red"
            >同济大学退休教职工需要填写工号，否则后续无法进行补贴申请</span
          >
        </FormItem>

        <FormItem style="text-align: left">
          <Button
            @click="resetUserInfo"
            style="margin-right: 20px; padding: 8px 24px; font-size: 18px"
            >重置</Button
          >
          <Button
            type="info"
            @click="submitUserInfo"
            style="padding: 8px 24px; font-size: 18px"
            >提交</Button
          >
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      idNumberType: "idCard",
      idNumberMap: {
        idCard: {
          name: "身份证",
        },
        passport: {
          name: "护照",
        },
        other: {
          name: "其他证件"
        }
      },
      idNumberData: {
        name: "身份证",
      },
      userInfoForm: {
        sid: "",
        name: "",
        sex: "",
        studentType: "",
        idNumberType: this.$route.query.idNumberType || "idCard",
        idCard: (this.$route.query.idCard || "").replace("x", "X"),
        birthDt: "",
        phone: "",
        email: "",
        address: "",
        emergencyContactName: "",
        emergencyContactPhone: "",
        education: "",
        workUnit: "",
      },
      userInfoRules: {
        // sid: [{ required: true, message: "工号不能为空", trigger: "blur" } ],
        name: [{ required: true, message: "姓名不能为空", trigger: "blur" }],
        sex: [{ required: true, message: "性别不能为空", trigger: "change" }],
        studentType: [
          { required: true, message: "类型不能为空", trigger: "change" },
        ],
        idNumberType: [
          { required: true, message: "证件类型不能为空", trigger: "change" },
        ],
        idCard: [
          {
            required: true,
            message: () => this.idNumberData.name + "号不能为空",
            trigger: "blur",
          },
        ],
        birthDt: [
          { required: true, message: "出生日期不能为空" },
        ],
        phone: [{ required: true, message: "手机号不能为空", trigger: "blur" }],
        address: [
          { 
            required: true, 
            message: "家庭地址不能为空", 
            trigger: "blur" 
          },
          {
            min: 5,
            max: 100,
            message: "地址长度必须在5-100个字符之间",
            trigger: "blur"
          }
        ],
        education: [
          { required: true, message: "学历不能为空", trigger: "blur" },
        ],
        workUnit: [
          { required: true, message: "工作单位不能为空", trigger: "blur" },
        ],
        emergencyContactName: [
          {
            required: true,
            message: "紧急联系人姓名不能为空",
            trigger: "blur"
          },
          {
            min: 2,
            max: 20,
            message: "紧急联系人姓名长度必须在2-20个字符之间",
            trigger: "blur"
          }
        ],
        emergencyContactPhone: [
          {
            required: true,
            message: "紧急联系人电话不能为空",
            trigger: "blur"
          },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的11位手机号码",
            trigger: "blur"
          }
        ],
      },
      telDisabled: false,
      idCardDisabled: false,
      sidDisabled: false,
      nameDisabled: false,
      sexDisabled: false,
    };
  },
  methods: {
    resetUserInfo() {
      // this.$refs.userInfoForm.resetFields();
      let arrTel = [
        "name",
        "sex",
        "studentType",
        "idCard",
        "birthDt",
        "phone",
        "email",
        "address",
        "emergencyContactName",
        "emergencyContactPhone",
        "education",
        "workUnit",
      ];
      let arrIdCard = [
        "name",
        "sex",
        "studentType",
        "birthDt",
        "phone",
        "email",
        "address",
        "emergencyContactName",
        "emergencyContactPhone",
        "education",
        "workUnit",
      ];
      if (!this.idCardDisabled) {
        arrTel.forEach((item) => {
          this.resetFiled("userInfoForm", item);
        });
      } else {
        arrIdCard.forEach((item) => {
          this.resetFiled("userInfoForm", item);
        });
      }
    },

    resetFiled(name, key) {
      this.$refs[name].fields.forEach(function (e) {
        if (e.prop === key) {
          e.resetField();
        }
      });
    },
    submitUserInfo() {
      console.log("userInfoForm", this.userInfoForm);
      this.$refs.userInfoForm.validate((valid) => {
        if (valid) {
          console.log("valid", valid);
          var _this = this;
          let formattedBirthDt  = null;
          if (_this.userInfoForm.idNumberType === "idCard") {
            // 格式化日期，只保留日期部分
            formattedBirthDt = _this.userInfoForm.birthDt.toISOString().split('T')[0];
           } else {
             formattedBirthDt = _this.userInfoForm.birthDt;
           }
          
     
          _this.$http
            .post("retire-school-manage/student/addStudent", {
              id: this.$route.query.id,
              sid: _this.userInfoForm.sid,
              name: _this.userInfoForm.name,
              sex: _this.userInfoForm.sex,
              studentType: _this.userInfoForm.studentType,
              idNumberType: _this.userInfoForm.idNumberType,
              idCard: _this.userInfoForm.idCard.replace("x", "X"),
              birthDt: formattedBirthDt,
              phone: _this.userInfoForm.phone,
              email: _this.userInfoForm.email,
              address: _this.userInfoForm.address,
              emergencyContactName: _this.userInfoForm.emergencyContactName,
              emergencyContactPhone: _this.userInfoForm.emergencyContactPhone,
              education: _this.userInfoForm.education,
              workUnit: _this.userInfoForm.workUnit,
            })
            .then(function (res) {
            
              if (res.data.status === 2000) {
                //存token student 跳转到首页
                sessionStorage.removeItem("token_retire_school");
                let token = res.data.data.token;
                sessionStorage.setItem("token_retire_school", token);
                _this.$store.commit("ADD_TOKEN", token);
            
                sessionStorage.removeItem("userNameSchool");
                let userName = res.data.data.name;
                sessionStorage.setItem("userNameSchool", userName);

                sessionStorage.removeItem("idCard");
                let idCard = res.data.data.idCard;
                sessionStorage.setItem("idCard", idCard);

                sessionStorage.removeItem("idNumberType");
                let idNumberType = res.data.data.idNumberType;
                sessionStorage.setItem("idNumberType", idNumberType);

                let studentId = res.data.data.id;
                sessionStorage.setItem("studentId", studentId);
                _this.$store.commit("ADD_STUDENTID", studentId);
               
                //_this.$router.push({ name: "home" });
                _this.$router.push({ path: "/" });
              } else {
                _this.$CustomMessageError(res.data.msg);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          console.log("请检查必填信息,userInfoForm", this.userInfoForm);
          this.$CustomMessageError("请检查必填信息!");
        }
      });
    },
    // 从身份证号码提取出生日期
    extractBirthDateFromIdCard(idCard) {
      if (idCard && idCard.length === 18) {
        const year = idCard.substring(6, 10);
        const month = idCard.substring(10, 12);
        const day = idCard.substring(12, 14);
        return `${year}-${month}-${day}`;
      }
      return '';
    },
  },
  mounted() {
    console.log("router query", this.$route.query);

    if (this.$route.query.idNumberType === 'idCard') {
      this.idCardDisabled = true;
      this.userInfoForm.birthDt = this.extractBirthDateFromIdCard(this.$route.query.idCard);
    }
    if (this.$route.query.name) {
      this.idCardDisabled = true;
      this.nameDisabled = true;
      this.sexDisabled = true;
      this.userInfoForm.sid = this.$route.query.sid;
      this.userInfoForm.name = this.$route.query.name;
      this.userInfoForm.sex = this.$route.query.sex;
      this.userInfoForm.studentType = this.$route.query.studentType;
      this.userInfoForm.idCard = this.$route.query.idCard.replace("x", "X");
      this.userInfoForm.phone = this.$route.query.phone;
      this.userInfoForm.email = this.$route.query.email;
      this.userInfoForm.address = this.$route.query.address;
      this.userInfoForm.education = this.$route.query.education;
      this.userInfoForm.workUnit = this.$route.query.workUnit;
      this.userInfoForm.phone = this.$route.query.phone;
    }

    if (this.$route.query.sid) {
      this.sidDisabled = true;
      this.userInfoForm.sid = this.$route.query.sid;
    }
  },
};
</script>
<style scoped>
.mainBox {
  width: 60%;
  margin: auto;
  padding: 0 15px;
  box-sizing: border-box;
}

.ivu-input {
  width: 100%;
  height: 40px !important;
  font-size: 16px !important;
}

@media screen and (max-width: 768px) {
  .mainBox {
    width: 100%;
    padding: 0 16px;
  }

  h2 {
    font-size: 20px;
    padding-bottom: 20px !important;
    padding-left: 0 !important;
    text-align: center;
  }

  .form-container :deep(.ivu-form-item) {
    display: flex !important;
    flex-direction: column !important;
    margin-bottom: 20px !important;
  }

  .form-container :deep(.ivu-form-item-label) {
    text-align: left !important;
    padding: 0 0 10px 0 !important;
    font-size: 16px !important;
    color: #333 !important;
    line-height: 1.5 !important;
    font-weight: 500 !important;
    width: 100% !important;
  }

  .form-container :deep(.ivu-form-item-content) {
    margin-left: 0 !important;
  }

  .form-container :deep(.ivu-form-item-error-tip) {
    padding-top: 4px !important;
    font-size: 13px !important;
  }

  .form-container :deep(.ivu-input[disabled]) {
    color: #666 !important;
    background-color: #f5f5f5 !important;
  }

  .form-container :deep(.ivu-form-item:last-child) {
    margin-top: 30px !important;
  }

  .form-container :deep(.ivu-btn) {
    width: 100% !important;
    margin: 0 !important;
    height: 46px !important;
    font-size: 16px !important;
    border-radius: 6px !important;
  }

  .form-container :deep(.ivu-form-item:last-child .ivu-form-item-content) {
    display: flex !important;
    flex-direction: column !important;
    gap: 12px !important;
  }
}
</style>
